import React from 'react'
import {Spinner} from '../../widgets/components/General/Spinner'
import {useIntl} from 'react-intl'
import NoDataPage from '../../widgets/components/NoDataPage'

interface LocationData {
  locationName: string
  visitCount: number
}

interface AppProps {
  locationCityData: LocationData[]
  locationCountryData: LocationData[]
  locationLoading: boolean
}

function App({locationCityData, locationCountryData, locationLoading}: AppProps): JSX.Element {
  const {formatMessage} = useIntl()

  return (
    <>
      {locationLoading ? <Spinner /> : ''}
      <div className='mt-5'>
        <h5 className='second-section-heading font-size-16 font-weight-500 font-weight-md-600 mb-5 ms-2'>
          {formatMessage({id: 'Visitor Locations'})}
        </h5>
        {locationCityData?.length > 0 ? (
          <div className='d-flex justify-content-between gap-4'>
            <div className='bg-white rounded-2 border border-muted border-2 p-6 w-100'>
              <table className='table table-row-bordered  space-table'>
                <thead>
                  <tr className=' '>
                    <th className='fw-bold'>{formatMessage({id: 'City'})}</th>
                    <th className='fw-bold'>{formatMessage({id: 'Visits'})}</th>
                  </tr>
                </thead>
                <tbody>
                  {locationCityData?.map((row: LocationData, index: number) => (
                    <tr key={index}>
                      <td>{row.locationName}</td>
                      <td>{row.visitCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className='bg-white rounded-2 border border-muted border-2 p-6 w-100'>
              <table className='table table-row-bordered space-table '>
                <thead>
                  <tr className=' '>
                    <th className='fw-bold'>{formatMessage({id: 'Country'})}</th>
                    <th className='fw-bold'>{formatMessage({id: 'Visits'})}</th>
                  </tr>
                </thead>
                <tbody>
                  {locationCountryData?.map((row: LocationData, index: number) => (
                    <tr key={index}>
                      <td>{row.locationName}</td>
                      <td>{row.visitCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <NoDataPage mainfileActivity={true} />
        )}
      </div>
    </>
  )
}

export default App
